// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"54f247f9","451":"15ff5ecf","453":"ce5c3f64"}[chunkId] + ".chunk.js";
};